import { PRODUCT_CONTEXT } from "common-ui-components/components/utils/Config";

const path = "/app/secure";
const isVM = PRODUCT_CONTEXT !== "pm";

export const patchRouteMeta = [
  {
    type: "route",
    key:"SECURE_OVERVIEW",
    path:`${path}/overview/*`
  },
  {
    type: "route",
    key: "MISSING_PATCHES",
    path: `${path}/patch-view/missing-patches`,
    exact: true,
  },
  {
    type: "route",
    key: "INSTALLED_PATCHES",
    path: `${path}/patch-view/installed-patches`,
    exact: true,
  },
  {
    type: "route",
    key: "ALL_PATCHES",
    path: `${path}/patch-view/all-patches`,
    exact: true,
  },
  isVM&&{
    type: "route",
    key: "VULNERABILITIES",
    path: `${path}/threats/vulnerabilities/*`,
    exact: true,
  },
  isVM && {
    type: "route",
    key: "CVE_DETAILS",
    path: `${path}/threats/vulnerabilities/cve-details/*`,
    exact: true,
  },
  {
    type: "route",
    key: "SCAN_DEVICES_PATCH",
    path: `${path}/devices/scan-devices`,
    exact: true,
  },
  {
    type: "route",
    key: "GROUP_DEVICE_PROFILE_OVERVIEW",
    path: `${path}/associations/:type/:id/:name`,
  },
  {
    type: "route",
    key: "SCAN_SYSTEM",
    path: `${path}/system/scan-system`,
    exact: true,
  },
  {
    type: "route",
    key: "MANUAL_DEPLOYMENT",
    path: `${path}/deployment/manual/*`,
  },
  isVM&&{
    type: "route",
    key: "HIGH_RISK_SOFTWARE",
    path: `${path}/threats/high-risk-software/*`,
  },
  isVM&&{
    type: "route",
    key: "ZERO_DAY",
    path: `${path}/threats/zero-day/*`,
  },
  isVM&&{
    type: "route",
    key: "PORT_AUDIT",
    path: `${path}/threats/port-audit/*`,
  },
  {
    type: "route",
    key: "APD",
    path: `${path}/deployment/apd/*`,
  },
  {
    type: "route",
    key: "TEST_AND_APPROVE",
    path: `${path}/deployment/test-and-approve/*`,
  },
  {
    type: "route",
    key: "BANDWIDTH_OPTIMIZATION",
    path: `${path}/settings/bandwidth-optimization`,
  },
  {
    type: "route",
    key: "PATCH_DB",
    path: `${path}/settings/db-sync/*`,
  },
  isVM&&{
    type: "route",
    key: "PATCH_REPORTS",
    path: `${path}/reports/*`
  },
  {
    type: "route",
    key: "VULNERABILITY_REPORTS",
    path: `${path}/vulnerability-reports/*`
  },
].filter(Boolean);
